


import { DATA_TABLE_ALIGN_HORIZONTAL } from '../../../../../common/constants/dataTableAlignHorizontal';

import { getDataTableCellRawValue } from './dataTableCellValueFactory';


import { DATA_TABLE_TREE_EXPANDER_ICON_SIZE } from '../../../../../common/constants/dataTableStyleVariables';

import { DATA_TABLE_TREE_STYLE_TYPE } from '../../../../../common/constants/dataTableTreeStyleType';
import { isDataTableTreeRowNodeRoot } from '../dataTableRow';


export const getDataTableCellContentStyleModifiers = (
column) => (
{
  alignHorizontal: column.alignHorizontal || DATA_TABLE_ALIGN_HORIZONTAL.START
});

export const getDataTableBodyCellStyleModifiers = (
row, column) =>
{
  const rawValue = getDataTableCellRawValue(row, column.field);
  let modifiers = {};

  /* istanbul ignore else  */
  if (column.getStyleModifiers) {
    modifiers = column.getStyleModifiers(rawValue, row, column);
  }

  return modifiers;
};

export const getDataTableBodyCellTreeStyles = (
treeRowNode,
treeStyleType) =>
{
  const { deepLevel } = treeRowNode;

  let shiftMultiplier = deepLevel;

  // Remove shift for first level child to align values with root as in accordion
  if (
  treeStyleType === DATA_TABLE_TREE_STYLE_TYPE.ACCORDION &&
  !isDataTableTreeRowNodeRoot(treeRowNode))
  {
    shiftMultiplier = deepLevel - 1;
  }

  return {
    marginLeft: `${shiftMultiplier * DATA_TABLE_TREE_EXPANDER_ICON_SIZE}px`,
    width: DATA_TABLE_TREE_EXPANDER_ICON_SIZE
  };
};

export const hasDataTableBodyCellExpander = (
isTree,
hasTreeData) =>
hasTreeData && isTree;